import WebGLPointsClass, * as WebGLPointsModule from './../../node_modules/ol/layer/WebGLPoints.js';

// Create a wrapper class
class WebGLPoints extends WebGLPointsClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in WebGLPointsModule) {
    if (key !== "default") {
        WebGLPoints[key] = WebGLPointsModule[key];
    }
}

export default WebGLPoints;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/WebGLPoints.js';